module.exports = __webpack_public_path__ + "static/media/yui-hatano-lose.42dc89ba.jpg";